import { partition, sortBy } from 'lodash-es'

const sortLocationsForBrandDefinitionTask = (locations, currentView) => {
  const locationsSortedById = sortBy(locations, 'id')

  const [
    locationsRequiringReview,
    locationsNotRequiringReview,
  ] = partition(locationsSortedById, location =>
    currentView.modifiedLocationIds.includes(Number(location.id)),
  )

  return [...locationsRequiringReview, ...locationsNotRequiringReview]
}

export default sortLocationsForBrandDefinitionTask
